module.exports = __webpack_public_path__ + "static/marinekauppa.006ab260.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/references/marinekauppa.png
// module id = 211
// module chunks = 35783957827783 267625579013595